





































































import Vue from "vue";
import FormSection from "@/components/FormSection.vue";
import IconButton from "@/components/IconButton.vue";
import { Flag } from "@/models/GlobalStore";
import store from "../services/GpartsEditStore";
import GpartOtherCostType, { OcostGpartOption, getFlags } from "../models/GpartOtherCostType";
import { t } from "@/plugins/i18n";

export default Vue.extend({
  components: { 
    FormSection, 
    IconButton 
  },
  data() {
    return { store };
  },
  methods: {
    optionItems(row: GpartOtherCostType) {
      const none = {
        id: 1,
        text: "-",
        isCarSale: false,
        isPostCalc: false,
        isCarRectItem: false,
        isNewPostCalcType: false,
        isShcPostCalcType: false,
        isStockPostCalcType: false,
      };
      return [
        none,
        ...row.options.map((o) => ({
          ...o,
          text: t("GpartsEdit_BejovoFkszKimenoFksz", [o.accCodeIn, o.accCodeOut, o.name]),
        })),
      ];
    },
    optionFlags(option: OcostGpartOption): Flag[] {
      return getFlags(option);
    },
    openGpart(id: number) {
      if (id <= 1) return;
      const route = this.$router.resolve({ name: "GpartEditor2", params: { partsID: String(id) } });
      window.open(route.href, "_blank");
    },
  },
});
